/**
 * Default fallback for the max playerIndex when the live value from
 * GET /admin/config/roster-size hasn't loaded yet (initial render) or
 * failed. Set to the current production max so admin forms stay usable
 * in any case.
 *
 * Runtime source of truth is the roster-size endpoint (cached at module
 * scope in services/api.ts, fetched at most once per admin session).
 * Bump this constant only when the production roster grows so the
 * fallback stays in sync with whatever the next deploy ships with.
 *
 * Mirrors PLAYER_INDEX_MAX in
 * wcc4-backend/src/modules/player-data/player-data.constants.ts.
 */
export const DEFAULT_MAX_PLAYER_INDEX = 123;
